$(document).ready(function () {
    /**
     * Affichage / masquage des listes déroulantes
     */
    $('.dropdown dt a').click(function (e) {
        e.preventDefault();

        var $this = $(this).parents('.dropdown').find('ul');
        $(".dropdown ul").not($this).hide();

        $this.toggle();
    });
    $('.dropdown ul').hide();

    /**
     * Gestion du clic sur les input:number min/max
     */
    $('.dropdown .multiSelect input[type="number"]').on('change', function () {
        var name = $(this).attr('name'); // budget_min, budget_max, surface_min, surface_max

        // On cherche si on vient de modifier un min ou un max
        if (name.indexOf('min') !== -1) {
            // Cas min
            var other = name.replace('_min', '_max');
            var min = $(this).val();
            var max = $('input[name="' + other + '"]').val();
        } else {
            // Cas max
            var other = name.replace('_max', '_min');
            var max = $(this).val();
            var min = $('input[name="' + other + '"]').val();
        }

        // Gestion des cas spécifiques min / max
        if (min != "" && max != "") {
            var title = min + " — " + max;
        } else {
            if (min != "") {
                var title = "> " + min;
            } else if (max != "") {
                var title = "< " + max;
            } else {
                var title = "default";
            }
        }

        // Gestion de surface vs budget et des unités
        if (name.indexOf('budget') !== -1) {
            var unit = " €";

            if (title == 'default') {
                title = "Budget";
                unit = "";
            }
        } else {
            var unit = " m²";

            if (title == 'default') {
                title = "Surface";
                unit = "";
            }
        }

        // Mise à jour du libellé au-dessus de la liste déroulante
        $(this).parents('.dropdown').find('.hida').text(title + unit);
    });
    $('.dropdown .multiSelect input[type="number"]').trigger('change');

    /**
     * Gestion des cases à cocher
     */
    $('.dropdown .multiSelect input[type="checkbox"]').on('change', function () {
        var checkboxes = $(this).parents('.multiSelect').find('input[type="checkbox"]:checked');
        var checked = [];

        // On stocke dans un tableau la valeur de toutes les cases cochées
        checkboxes.each(function (index, item) {
            checked.push($(item).val());
        });

        var type = $(this).parents('.multiSelect').data('label');
        var title = checked.join(', ') + " " + type;

        // Gestion des cas particuliers
        if (checked.length > 3) {
            title = checked.length + " choix";
        } else if (checked.length == 0) {
            title = $(this).parents('.dropdown').find('label').first().text();
        } else if (checked.length > 1) {
            title += "s";
        } else if (checked.length == 1 && checked[0] != 1) {
            title += "s";
        }

        // Cas villes et quartiers : on affiche directement « n choix »
        if ($(this).attr('name').indexOf('quartiers') !== -1 || $(this).attr('name').indexOf('villes') !== -1) {
            title = checked.length + " choix";

            if (checked.length == 0) {
                title = $(this).parents('.dropdown').find('.heading').first().text();
            }
        }

        // Mise à jour du libellé au-dessus de la liste déroulante
        $(this).parents('.dropdown').find('.hida').text(title);
    });
    $('.dropdown .multiSelect input[type="checkbox"]').trigger('change');
});